"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ToLong_1 = require("./ToLong");
function isReserved(ipaddress) {
    return ipInReservedRange(ipaddress);
}
exports.isReserved = isReserved;
// Taken from wikipedia https://en.wikipedia.org/wiki/Reserved_IP_addresses
var RESERVED_RANGES = [
    ['0.0.0.0', '0.255.255.255'],
    ['10.0.0.0', '10.255.255.255'],
    ['100.64.0.0', '100.127.255.255'],
    ['127.0.0.0', '127.255.255.255'],
    ['169.254.0.0', '169.254.255.255'],
    ['172.16.0.0', '172.31.255.255'],
    ['192.0.0.0', '192.0.0.255'],
    ['192.0.2.0', '192.0.2.255'],
    ['192.88.99.0', '192.88.99.255'],
    ['192.168.0.0', '192.168.255.255'],
    ['198.18.0.0', '198.19.255.255'],
    ['198.51.100.0', '198.51.100.255'],
    ['203.0.113.0', '203.0.113.255'],
    ['224.0.0.0', '239.255.255.255'],
    ['240.0.0.0', '255.255.255.255']
];
function ipInReservedRange(ipaddress) {
    var inRange = false;
    try {
        for (var RESERVED_RANGES_1 = tslib_1.__values(RESERVED_RANGES), RESERVED_RANGES_1_1 = RESERVED_RANGES_1.next(); !RESERVED_RANGES_1_1.done; RESERVED_RANGES_1_1 = RESERVED_RANGES_1.next()) {
            var range = RESERVED_RANGES_1_1.value;
            if (ipInRange(ipaddress, range)) {
                inRange = true;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (RESERVED_RANGES_1_1 && !RESERVED_RANGES_1_1.done && (_a = RESERVED_RANGES_1.return)) _a.call(RESERVED_RANGES_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return inRange;
    var e_1, _a;
}
function ipInRange(ipaddress, range) {
    var ip = ToLong_1.toLong(ipaddress);
    var startRange = ToLong_1.toLong(range[0]);
    var endRange = ToLong_1.toLong(range[1]);
    return ip >= startRange && ip <= endRange;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXNSZXNlcnZlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIklzUmVzZXJ2ZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQWlDO0FBRWpDLG9CQUE0QixTQUFpQjtJQUMzQyxNQUFNLENBQUMsaUJBQWlCLENBQUMsU0FBUyxDQUFDLENBQUE7QUFDckMsQ0FBQztBQUZELGdDQUVDO0FBQ0QsMkVBQTJFO0FBQzNFLElBQU0sZUFBZSxHQUFHO0lBQ3RCLENBQUMsU0FBUyxFQUFFLGVBQWUsQ0FBQztJQUM1QixDQUFDLFVBQVUsRUFBRSxnQkFBZ0IsQ0FBQztJQUM5QixDQUFDLFlBQVksRUFBQyxpQkFBaUIsQ0FBQztJQUNoQyxDQUFDLFdBQVcsRUFBRSxpQkFBaUIsQ0FBQztJQUNoQyxDQUFDLGFBQWEsRUFBRSxpQkFBaUIsQ0FBQztJQUNsQyxDQUFDLFlBQVksRUFBRSxnQkFBZ0IsQ0FBQztJQUNoQyxDQUFDLFdBQVcsRUFBRSxhQUFhLENBQUM7SUFDNUIsQ0FBQyxXQUFXLEVBQUUsYUFBYSxDQUFDO0lBQzVCLENBQUMsYUFBYSxFQUFFLGVBQWUsQ0FBQztJQUNoQyxDQUFDLGFBQWEsRUFBRSxpQkFBaUIsQ0FBQztJQUNsQyxDQUFDLFlBQVksRUFBRSxnQkFBZ0IsQ0FBQztJQUNoQyxDQUFDLGNBQWMsRUFBRSxnQkFBZ0IsQ0FBQztJQUNsQyxDQUFDLGFBQWEsRUFBRSxlQUFlLENBQUM7SUFDaEMsQ0FBQyxXQUFXLEVBQUUsaUJBQWlCLENBQUM7SUFDaEMsQ0FBQyxXQUFXLEVBQUUsaUJBQWlCLENBQUM7Q0FDakMsQ0FBQTtBQUVELDJCQUE0QixTQUFpQjtJQUMzQyxJQUFJLE9BQU8sR0FBRyxLQUFLLENBQUE7O1FBQ25CLEdBQUcsQ0FBQyxDQUFjLElBQUEsb0JBQUEsaUJBQUEsZUFBZSxDQUFBLGdEQUFBO1lBQTVCLElBQUksS0FBSyw0QkFBQTtZQUNaLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUNoQyxPQUFPLEdBQUcsSUFBSSxDQUFBO2dCQUNkLEtBQUssQ0FBQTtZQUNQLENBQUM7U0FDRjs7Ozs7Ozs7O0lBQ0QsTUFBTSxDQUFDLE9BQU8sQ0FBQTs7QUFDaEIsQ0FBQztBQUVELG1CQUFvQixTQUFpQixFQUFFLEtBQWU7SUFDcEQsSUFBSSxFQUFFLEdBQUcsZUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFBO0lBQzFCLElBQUksVUFBVSxHQUFHLGVBQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUNqQyxJQUFJLFFBQVEsR0FBRyxlQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDL0IsTUFBTSxDQUFDLEVBQUUsSUFBSSxVQUFVLElBQUksRUFBRSxJQUFJLFFBQVEsQ0FBQTtBQUMzQyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/IsReserved.ts
// module id = 14
// module chunks = 0